import { Directive, ElementRef, Injector, Renderer2, ViewContainerRef } from '@angular/core';

import { BaseErrorsDirective } from './base-errors.directive';
import { ErrorsComponent } from './errors.component';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: `
    pcs-input[formControl]:not([container='body']),pcs-input[formControlName]:not([container='body']),
    pcs-input[ngrxFormControlState]:not([container='body']),
    pcs-textarea[formControl]:not([container='body']),pcs-textarea[formControlName]:not([container='body']),
    pcs-textarea[ngrx-form-control-state]:not([container='body']),
    pcs-datepicker[formControl]:not([container='body']),pcs-datepicker[formControlName]:not([container='body']),
    pcs-datepicker[ngrxFormControlState]:not([container='body']),
    pcs-single-select[formControl]:not([container='body']),pcs-single-select[formControlName]:not([container='body']),
    pcs-single-select[ngrxFormControlState]:not([container='body']),
    pcs-multi-select[formControl]:not([container='body']),pcs-multi-select[formControlName]:not([container='body']),
    pcs-multi-select[ngrxFormControlState]:not([container='body'])
  `
})
export class HostErrorsDirective extends BaseErrorsDirective {

  private componentRef = null;

  constructor(
    protected readonly element: ElementRef,
    protected readonly renderer: Renderer2,
    protected readonly injector: Injector,
    private readonly viewContainer: ViewContainerRef
  ) {
    super(injector, element, renderer);
  }

  protected attach() {
    this.componentRef = this.viewContainer.createComponent(ErrorsComponent, {injector: this.errorsComponentInjector()});
    const host = this.element.nativeElement;
    this.renderer.insertBefore(host, this.componentRef.location.nativeElement, host.firstChild);
  }

  protected detach() {
    if (this.componentRef) {
      this.renderer.removeChild(this.element.nativeElement, this.componentRef.location.nativeElement);
      this.componentRef = null;
    }
  }

}
